import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-service-gaz',
  templateUrl: './service-gaz.component.html',
  styleUrls: ['./service-gaz.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceGazComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {}
  toOrdering() {
    this.router.navigate(['/']);
  }
}
